import React from 'react';
import { motion } from 'framer-motion';

const projects = [
  'DropWave',
  'Brimstone Retreats',
  'GiftDaddy',
];

const ProjectsV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-white border border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 mb-8">Projects</h2>
        <div className="grid md:grid-cols-3 gap-5">
          {projects.map((project, i) => (
            <motion.div
              key={project}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              viewport={{ once: true }}
              className="rounded-xl bg-gray-50 p-6 shadow-md hover:shadow-lg hover:-translate-y-2 transition-all duration-300"
            >
              <h3 className="text-xl font-semibold text-gray-900">{project}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsV3;
